// Port of api/fuel/app/classes/filter/search/games/sorts/query/game/firstpublished.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'firstyear',
	post: false,
	require: function(config, filter) { return sorted('firstyear', filter) > 0 },
	run: function(config, filter, data, query) {
		query.order('g.game_published', sortReverse('year', filter), sortPriority('year', filter))
	}
}
